import type { SectionTokenClasses } from '../ModularTypes/SectionSettings';

type ClassValue = string | undefined | null;

export class SectionClassBuilder {
  static build(
    props: SectionTokenClasses,
    context: SectionTokenClasses = {},
  ): string {
    const get = (prop: keyof SectionTokenClasses): string | undefined =>
      props[prop] || context[prop];

    const toClass = (prefix: string, value?: string) =>
      value ? `${prefix}-${value}` : null;

    return [
      'section',
      props.className ?? context.className,
      get('layout'),

      toClass('flex', get('flex')),
      toClass('flex-direction', get('flexDirection')),
      toClass('flex-wrap', get('flexWrap')),
      toClass('gap', get('gap')),
      toClass('width', get('width')),
      toClass('width-max', get('widthMax')),
      toClass('height', get('height')),
      toClass('grid-template', get('gridTemplate')),
      toClass('grid-area', get('gridArea')),
      toClass('col-span', get('colSpan')),
      toClass('row-span', get('rowSpan')),
      toClass('justify-content', get('justifyContent')),
      toClass('justify-items', get('justifyItems')),
      toClass('align-content', get('alignContent')),
      toClass('align-items', get('alignItems')),
      toClass('justify-self', get('justifySelf')),
      toClass('align-self', get('alignSelf')),
      toClass('padding-left', get('paddingLeft')),
      toClass('padding-right', get('paddingRight')),
      toClass('padding-top', get('paddingTop')),
      toClass('padding-bottom', get('paddingBottom')),
      toClass('margin-left', get('marginLeft')),
      toClass('margin-right', get('marginRight')),
      toClass('margin-top', get('marginTop')),
      toClass('margin-bottom', get('marginBottom')),
      toClass('bg', get('background')),
      toClass('box-shadow', get('boxShadow')),
      toClass('border-color', get('borderColor')),
      toClass('border-radius', get('borderRadius')),
      toClass('backdrop-filter', get('backdropFilter')),
      toClass('z-index', get('zIndex')),
    ]
      .filter(this.isValid)
      .join(' ');
  }

  static isValid(value: ClassValue): value is string {
    return typeof value === 'string' && value.trim() !== '';
  }
}
